<template>
  <!-- 优惠券卡片组件 -->
  <div class="productCard" :class="calssComputed">
    <div class="fvlru titleBox">
      <div class="title">{{ datas.rightName }}</div>
      <!-- statusFlag=1 可使用 列表需展示 是否过期标识 -->
      <div class="coupon-reminder" v-if="datas.isHasReminderCoupon && listStatusFlag === 1">即将过期</div>
      <div v-if="isShowActiveBtn" class="toActive" @click="toActive">去激活</div>
    </div>
    <div class="contentBox" @click.stop="showRightDetail(datas)">
      <div class="fvlru itemInfo">
        <div class="itemInfo proName ellipsis">{{ datas?.couponContent?.childProductName || '产品名称缺失' }}</div>
        <div class="shopStatus ellipsis">{{ status(datas) }}</div>
      </div>

      <div class="fvl itemInfo">
        <div class="content halfWidth">
          券码：<span class="text">{{ datas?.couponCode || '' }}</span>
        </div>
        <!-- <div class="content">
          有效期：<span class="text">{{ '12个月' }}</span>
        </div> -->
      </div>
      <div class="fvl itemInfo">
        <div class="content">
          合同编码：<span class="text">{{ datas?.contractCode || '' }}</span>
        </div>
      </div>
      <div class="fvl itemInfo">
        <div class="content" v-if="isEwCoupon(datas)">
          有效期：<span class="text">{{ getActiveaMonth(datas) }}</span>
        </div>
        <div class="content" v-else>
          有效期/有效使用里程：<span class="text">{{ getModActiveaMonth(datas) }}</span>
        </div>
      </div>
      <div class="fvl itemInfo">
        <div class="content">
          车辆：<span class="text">{{ datas?.carInfo?.plate }} {{ datas?.carInfo?.model }}</span>
        </div>
      </div>
      <template v-if="isEwCoupon(datas)">
        <template v-if="isEwCouponActivated(datas)">
          <div class="fvl itemInfo">
            <div class="content">
              生效日期：<span class="text">{{ `${datas.activeStartTime}` }}</span>
              （如因特殊原因涉及变更，请咨询经销商确认）
            </div>
          </div>
          <div class="fvl itemInfo">
            <div class="content">
              失效日期：<span class="text">{{ datas?.activeMonth === -1 ? '-' : `${datas.activeEndTime}` }}</span>
              <span v-if="datas?.productType !== 'PRD_CATEGORY_7'">（如车辆行驶里程先于产品结束日期达到产品结束时车辆总行驶里程，以该时间为产品结束日期）</span>
            </div>
          </div>
        </template>
      </template>
      <div class="fvl itemInfo" v-else>
        <div class="content">
          生效时间：<span class="text">{{ getActiveTime(datas)?.str || '' }}</span>
        </div>
      </div>
      <div class="fvlru itemInfo">
        <div class="fvl" @click.stop="viewUseDealerFn(datas)">
          可使用经销商：
          <div class="content">
            <span class="text underline"> 点击查看 </span>
          </div>
        </div>
      </div>
      <!-- 保养&延保 -->
      <div class="fvlru dealer" v-if="isEwCoupon(datas) || isScCoupon(datas)">
        <div class="fvl" @click.stop="viewContractFn(datas)">
          产品告知书：
          <div class="content">
            <span class="text underline"> 点击查看 </span>
          </div>
        </div>
        <div class="themeColor">
          详情 >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { EWCouponType } from '@/util/order/staticConfig'
import { getStatusName, getActiveTime, getModActiveaMonth, getActiveaMonth } from '@/util/directSales'

export default {
  props: {
    datas: {
      type: Object,
      default: () => {}
    },
    disable: {
      type: Boolean,
      default: false
    },
    listStatusFlag: {
      type: Number
    }
  },
  emits: ['showProductDetail', 'viewUse', 'viewContract'],
  setup(props, { emit }) {
    const router = useRouter()
    let { datas, disable, listStatusFlag } = toRefs(props)
    const state = reactive({
      datas,
      disable,
      listStatusFlag
    })
    // 触发点击事件
    const showRightDetail = data => {
      emit('showProductDetail', data)
    }
    const viewUseDealerFn = data => {
      emit('viewUse', data)
    }
    const viewContractFn = data => {
      emit('viewContract', data)
    }
    let status = val => {
      return getStatusName(val)
    }
    const isShowActiveBtn = computed(() => [2, 5, 6].includes(state.datas?.couponType) && state.datas?.statusFlag === 6)
    const toActive = () => {
      router.push({ path: '/orderList', query: { status: 2 } })
    }
    const calssComputed = computed(() => {
      let res = []
      // 2: 保养套餐 3:礼包 5:NEV 6:易损件  7:MOD直销礼包
      if (state.datas?.couponType === 3 || state.datas?.couponType === 7) {
        res.push('libao')
      } else {
        res.push('heyue')
      }
      // -- 	待生效 1 -- 	已生效 2
      res.push([1, 2].includes(state.datas?.statusFlag) ? 'canUse' : 'unUse')
      return res
    })
    const isEwCouponActivated = data => {
      return data.couponType === EWCouponType && data.statusFlag !== 6
    }
    const isEwCoupon = data => {
      return data.couponType === EWCouponType
    }
    const isScCoupon = data => {
      return data.couponType === 2
    }
    return {
      ...toRefs(state),
      showRightDetail,
      viewUseDealerFn,
      viewContractFn,
      status,
      calssComputed,
      getActiveTime,
      toActive,
      isShowActiveBtn,
      getModActiveaMonth,
      isEwCoupon,
      isScCoupon,
      isEwCouponActivated,
      getActiveaMonth
    }
  }
}
</script>

<style lang="scss" scoped>
.productCard {
  position: relative;
  margin-top: 16px;
  padding: 0 0 12px;
  font-size: 0px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.08);
}
.toActive {
  padding: 2px 8px;
  font-size: 12px;
  border: 1px solid #44a7ad;
  background: #44a7ad;
  border-radius: 2px;
}
.heyue {
  .titleBox {
    background: #787bc0;
  }
}
.libao {
  .titleBox {
    background: #44a7ad;
  }
}
.canUse .shopStatus {
  // color: #f34336;
  color: #44a7ad;
  border: 1px solid #44a7ad;
}
.unUse .shopStatus {
  color: #9ba2b4;
  border: 1px solid #e1e1e1;
}
.productCard .titleBox {
  padding: 10px 15px;
  color: #fff;
  font-size: 14px !important;
  box-sizing: border-box;
}

.productCard .contentBox {
  font-size: 14px;
  color: #666;
  padding: 16px 20px 0 20px;
  box-sizing: border-box;
  // background: #ffffff;
  .content {
    text-align: left;
  }
  .proName {
    font-size: 14px;
    font-weight: 700;
  }
  .text {
    font-size: 12px;
    opacity: 0.8;
  }
}
.itemInfo {
  margin-bottom: 8px;
  .halfWidth {
    width: 50%;
  }
}
.shopStatus {
  width: 50px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  // color: #3088c5;
  border: 1px solid transparent;
}
.phone {
  font-size: 24px;
  color: #3088c5;
  transform: rotate(-90deg);
  float: right;
}
.coupon-reminder{
  margin-left: 10px;
  font-size: 10px;
  color: red;
}
</style>
